/* eslint-disable react/prop-types */
import { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';
import { AiFillLock, AiFillUnlock } from 'react-icons/ai';
import { SlCalender } from 'react-icons/sl';
import { CgProfile } from 'react-icons/cg';
import { FiMenu, FiShoppingCart, FiX } from 'react-icons/fi';
import { GiPeanut } from 'react-icons/gi';
import { AdminContext } from '../../Context/AdminContext';

function Header({ variant = 'default' }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, canAdmin, logout, items } = useContext(AdminContext);
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await logout();
      navigate('/');
      setIsMenuOpen(false);
    } catch (error) {
      console.error('Unable to sign out:', error);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen((prevState) => !prevState);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  if (variant === 'storefront') {
    const cartCount = items.reduce((total, item) => total + Number(item.selectedQuantity || 0), 0);
    return (
      <header className='site-header storefront-site-header'>
        <div className='header-shell storefront-header-shell'>
          <Link className='storefront-wordmark' to='/' onClick={closeMenu}>
            <strong>Aunt Jack&apos;s</strong><span>Peanut Shack</span>
          </Link>
          <div className='storefront-mobile-actions'>
            <Link className='storefront-mobile-cart' to={user ? '/cart' : '/auth'} state={!user ? { returnTo: '/cart' } : undefined} aria-label={`Cart with ${cartCount} items`}>
              <FiShoppingCart aria-hidden='true' /><strong>{cartCount}</strong>
            </Link>
            <button type='button' className={`storefront-menu-toggle ${isMenuOpen ? 'is-open' : ''}`} onClick={toggleMenu} aria-expanded={isMenuOpen} aria-controls='storefront-navigation'>
              {isMenuOpen ? <FiX /> : <FiMenu />}<span className='sr-only'>{isMenuOpen ? 'Close menu' : 'Open menu'}</span>
            </button>
          </div>
          <nav id='storefront-navigation' className={`storefront-nav ${isMenuOpen ? 'is-open' : ''}`}>
            <Link to='/shop' onClick={closeMenu}>Shop</Link>
            <Link to='/events' onClick={closeMenu}>Events</Link>
            <Link to='/catering' onClick={closeMenu}>Catering</Link>
            <a href='/#story' onClick={closeMenu}>Our Story</a>
            <Link to={user ? '/profile' : '/auth'} state={!user ? { returnTo: '/shop' } : undefined} onClick={closeMenu}>Account</Link>
            <Link className='storefront-cart-link' to={user ? '/cart' : '/auth'} state={!user ? { returnTo: '/cart' } : undefined} onClick={closeMenu}>
              <FiShoppingCart aria-hidden='true' /> Cart <strong>{cartCount}</strong>
            </Link>
          </nav>
        </div>
      </header>
    );
  }

  return (
    <header className='site-header'>
      <div className='header-shell'>
        <div className='header-brand'>
          <Link className='brand-link' to={'/'}>
            <span className='brand-kicker'>Aunt Jack&apos;s</span>
            <span className='brand-title'>Peanut Shack</span>
          </Link>
          <p className='brand-tagline'>Small-batch boiled peanuts cooked with heart and Southern hospitality.</p>
        </div>

        <button
          type='button'
          className={`menu-toggle ${isMenuOpen ? 'is-open' : ''}`}
          onClick={toggleMenu}
          aria-expanded={isMenuOpen}
          aria-controls='primary-navigation'
        >
          {isMenuOpen ? <FiX className='menu-icon' /> : <FiMenu className='menu-icon' />}
          <span className='sr-only'>{isMenuOpen ? 'Close menu' : 'Open menu'}</span>
        </button>

        <nav id='primary-navigation' className={`header-nav ${isMenuOpen ? 'is-open' : ''}`}>
          <Link className='nav-item' to={'/events'} onClick={closeMenu}>
            <SlCalender className='nav-icon' />
            <span>Events</span>
          </Link>
          <Link className='nav-item' to={'/catering'} onClick={closeMenu}>
            <GiPeanut className='nav-icon' />
            <span>Catering</span>
          </Link>
          <Link className='nav-item' to={'/profile'} onClick={closeMenu}>
            <CgProfile className='nav-icon' />
            <span>My Account</span>
          </Link>
          {user ? (
            <button type='button' className='nav-item auth-button' onClick={handleSignOut}>
              <AiFillUnlock className='nav-icon' />
              <span>Sign out</span>
            </button>
          ) : (
            <Link className='nav-item' to={'/auth'} onClick={closeMenu}>
              <AiFillLock className='nav-icon' />
              <span>Sign in</span>
            </Link>
          )}
          {canAdmin ? (
            <Link className='nav-item' to='/admin' onClick={closeMenu}>
              <span>Admin</span>
            </Link>
          ) : null}
          <Link className='cta-button' to={'/shop'} onClick={closeMenu}>
            Order peanuts
          </Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;
